function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useCallback, useState } from "react";
import { sortDates } from "./helpers";

/**
 * Sequencing logic for setting an incoming date relative to an existing date range.
 * It has no opinion on if the second selection must be larger than the first selection.
 * 
 * Flow: first date selection -> second date selection -> first date selection -> second date selection -> (etc.)
 * @param {Array.<Date|null>} oldRange - Tuple with starting date and ending date
 * @param {Date} incomingDate - The next date to sequence
 * @returns tuple the newly set date range
 */
export var stepSequencer = function stepSequencer(existingRange, nextDate) {
  var _existingRange = _slicedToArray(existingRange, 2),
    rangeStartDate = _existingRange[0],
    rangeEndDate = _existingRange[1];
  var isRangeEmpty = !rangeStartDate && !rangeEndDate;
  var shouldResetRange = rangeStartDate && rangeEndDate;
  return isRangeEmpty || shouldResetRange ? [nextDate, null] : sortDates([rangeStartDate, nextDate]);
};

/**
 * Hook for storing date range state. Currently uses a step sequence, but has
 * room for flexibility in the future.
 */
var useADateRange = function useADateRange(config) {
  // Support older version hook config
  var initialRange;
  var maxDays;
  var isUsingOldParams = Array.isArray(config);
  if (isUsingOldParams) {
    initialRange = config || [null, null];
  } else {
    initialRange = Array.isArray(config === null || config === void 0 ? void 0 : config.initialRange) ? config.initialRange : [null, null];
    maxDays = (config === null || config === void 0 ? void 0 : config.maxDays) || null;
  }
  var _useState = useState(initialRange),
    _useState2 = _slicedToArray(_useState, 2),
    range = _useState2[0],
    setRange = _useState2[1];
  var _range = _slicedToArray(range, 2),
    firstSelection = _range[0],
    secondSelection = _range[1];
  var minDate, maxDate;
  if (maxDays && firstSelection && !secondSelection) {
    minDate = new Date(firstSelection);
    // Offset by 1 since one date is already selected
    minDate.setDate(firstSelection.getDate() - (parseInt(maxDays) - 1));
    maxDate = new Date(firstSelection);
    // Offset by 1 since one date is already selected
    maxDate.setDate(firstSelection.getDate() + (parseInt(maxDays) - 1));
  }
  if (maxDays && firstSelection && secondSelection) {
    minDate = null;
    maxDate = null;
  }
  var onChange = useCallback(function (incomingDate) {
    setRange(function (oldRange) {
      return stepSequencer(oldRange, incomingDate);
    });
  }, [setRange]);
  return {
    value: range,
    onChange: onChange,
    minDate: minDate,
    maxDate: maxDate
  };
};
export default useADateRange;